module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/features.json
// module id = 771
// module chunks = 56980643304056